<script lang="ts">
    export let flags: Flag[];
    export let width: number = 600;

    const exportWidth = 700;
    const exportHeight = 450;

    $: height = (exportHeight / exportWidth) * width;

    let svg: SVGElement;

    let equalWidth = false;
    $: singleFlagWidth = width / flags.length;
    $: singleStripeWidth = width / flags.reduce((a, f) => a + f.colors.length, 0);

    $: x = (i: number, j: number, flag: Flag): number =>
        equalWidth
            ? Math.floor(singleStripeWidth * (flags.reduce(
                (acc, flag, fIdx) => acc + (
                    fIdx < i 
                        ? flag.colors.length 
                        : fIdx === i ? j : 0
                ), 0)
            ))
            : Math.floor((i * singleFlagWidth) + j * (singleFlagWidth / flag.colors.length));

    $: w = (flag: Flag) =>
        equalWidth
            ? Math.ceil(singleStripeWidth)
            : Math.ceil(singleFlagWidth / flag.colors.length);

    const downloadResult = (size: number = 1) => {
        var canvas = document.createElement("canvas");
        canvas.width = exportWidth * size;
        canvas.height = exportHeight * size;
        var data = new XMLSerializer().serializeToString(svg);
        var img = new Image();
        var blob = new Blob([data], { type: 'image/svg+xml' });
        var url = window.URL.createObjectURL(blob);
        img.onload = function () {
            canvas.getContext('2d').drawImage(img, 0, 0, exportWidth * size, exportHeight * size);
            window.URL.revokeObjectURL(url);
            var uri = canvas.toDataURL('image/png').replace('image/png', 'octet/stream');
            var a = document.createElement('a');
            document.body.appendChild(a);
            a.style.display = 'none';
            a.href = uri;
            a.download = (flags.map(f => f.id.replace('-', '_')).join('-')) + (equalWidth ? '-equal' : '') + '.png';
            a.click();
            window.URL.revokeObjectURL(uri);
            document.body.removeChild(a);
        };
        img.src = url;
    }
</script>

<svg class="canvas" {width} {height} bind:this={svg}>
    <g>
        {#each flags as flag, i}
            <g>
                {#each flag.colors as color, j}
                    <rect
                        x={x(i, j, flag)}
                        y={0}
                        width={w(flag)}
                        {height}
                        fill={`#${color}`}
                    ></rect>
                {/each}
            </g>
        {/each}
    </g>
</svg>
<label>
    <input type="checkbox" name="equal-width" id="equal-width" bind:checked="{equalWidth}">
    equal width stripes?
</label>
<div class="downloads">
    {#each [1, 3] as s}
        <button on:click={() => downloadResult(s)}>download result (png, {exportWidth * s}px x {exportHeight * s}px)</button>
    {/each}
</div>

<style lang="scss">
    svg {
        stroke: none;
    }

    label {
        color: $black;
        font-family: $font;

        @media (prefers-color-scheme: dark) {
            color: $white;
        }
    }

    .downloads {
        button {
            color: $black;
        }
    }
</style>
